import { FormControl } from "@angular/forms";
export function selectRequired(input: FormControl) {
    return input.value == 0 ? { selectRequired: true } : null;
}
export function validateZipcode(input: FormControl) {
    let regex = /^[0-9]{5}(?:-[0-9]{4})?$/;
    return regex.test(input.value.toString()) ? null : { validateZipcode: true };
}
export function validatePhone(input: FormControl){
    let regex = /^\(?(\d{3})\)?[-\. ]?(\d{3})[-\. ]?(\d{4})( x\d{4})?$/;
    let result = input.value ? regex.test(input.value.toString()) : true;
    return result ? null : { validatePhone: true };
}


// WEBPACK FOOTER //
// ./src/app/services/custom-validate/custom-validate.ts